import { Component, Inject, OnInit } from '@angular/core';
import { DialogComponent, ButtonComponent } from '@rcp/common-web';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialogData } from '@core/constants/confirmation-dialog.constants';

import { ButtonStyle, ButtonType } from '@rcp/common-web';
@Component({
    selector: 'rcp-oup-confirmation-dialog',
    imports: [DialogComponent, ButtonComponent],
    templateUrl: './confirmation-dialog.component.html',
    styleUrl: './confirmation-dialog.component.scss',
})
export class ConfirmationDialogComponent implements OnInit {
    title: string;
    icon: string;
    confirmText: string;
    cancelText: string;
    message: string;

    constructor(
        private dialogRef: MatDialogRef<ConfirmationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogData,
    ) {}

    ngOnInit() {
        this.title = this.data?.title ? this.data.title : 'Confirm';
        this.icon = this.data?.icon ? this.data.icon : '';
        this.confirmText = this.data?.confirmText
            ? this.data.confirmText
            : 'Ok';
        this.cancelText = this.data?.cancelText
            ? this.data.cancelText
            : 'Cancel';
        this.message = this.data?.message
            ? this.data.message
            : 'Please confirm this action.';
    }

    confirm() {
        this.dialogRef.close(true);
    }

    cancel() {
        this.dialogRef.close(false);
    }

    protected readonly ButtonType = ButtonType;
    protected readonly ButtonStyle = ButtonStyle;
}
